<template>
  <b-row class="contato-row mb-50">
    <b-col>
      <cabecalho-repeticao
        titulo="Adicione os contatos"
        :inativo="value.usuarioInativo"
        @apply="adicionarItem"
        @remove="removerItem"
      />
      <b-row>
        <b-col
          cols="4"
          class="pr-0"
        >
          <div style="display: flex;">
            <div>
              <legend style="font-size: 14px;">
                Usuário
              </legend>
            </div>
            <b-btn
              v-b-tooltip.hover.top
              title="Abrir cadastro em nova aba"
              size="sm"
              variant="none"
              class="btn-actions"
              style="width: 35px;margin-left: -0.5rem;margin-top: -0.4rem;cursor: pointer;"
              @click="abrirGridUsuarioExterno"
            >
              <font-awesome-icon
                :icon="faExternalLinkAlt"
                :class="'text-primary'"
                style="width:22px"
              />
            </b-btn>
          </div>
          <usuario-externo-select
            ref="usuarioContato"
            v-model="valueInner.usuario"
            :title-popover="nomeUsuario()"
            class="usuario-select"
            :label="''"
            :invalido="valueInner.erro && valueInner.erro['usuario']"
            :filtro-adicional="removerUsuarioDuplicado"
            :filtro="filtroUsuarioEmpresa"
            :ignorar-primeiro-acesso="true"
            @input="atualizaLinha"
          />
        </b-col>
        <b-col
          cols="6"
          class="pr-0 pl-50"
        >
          <departamento-select
            ref="depContato"
            v-model="valueInner.departamentos"
            :disabled="!valueInner.usuario"
            :multiple="true"
            :require="valueInner.usuario !== null"
            :invalido="valueInner.erro && valueInner.erro['departamento']"
            :filtro-adicional="filtrarDepartamentosPorUsuario"
            @input="carregarDocumentos"
          />
        </b-col>
        <b-col
          cols="2"
          class="pl-50"
        >
          <b-form-group label="Função">
            <b-input
              :disabled="true"
              :value="funcao"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col
          cols="4"
          class="pr-0"
        >
          <div>
            <b-form-group label="E-mail">
              <b-input
                :disabled="true"
                :value="email"
              />
            </b-form-group>
            <b-form-checkbox
              v-model="valueInner.receberEmail"
              :disabled="!valueInner.usuario"
              :value="true"
              size="sm"
              class="detail-check-sm"
              style="margin-top: -0.8rem;"
            >
              Receber e-mail
            </b-form-checkbox>
          </div>
        </b-col>
        <b-col
          cols="8"
          class="pl-50"
        >
          <div class="div-email">
            <div>
              <legend style="font-size: 14px;">
                E-mails em Cópia (CC)</legend>
            </div>
            <div style="padding-left: 0.4rem">
              <i
                v-b-tooltip.hover
                title="Emails que irão receber uma cópia das notificações enviadas ao contato"
                style="font-size: 0.65rem;"
                class="question-icon"
              >
                <font-awesome-icon
                  :icon="faQuestionCircle"
                />
              </i>
            </div>
          </div>
          <b-form-tags
            v-model="valueInner.emailsCC"
            input-id="tags-emails"
            placeholder=""
            separator=" "
            invalid-tag-text=""
            duplicate-tag-text=""
            :tag-validator="validator"
            :disabled="disable"
            :add-button-text="'Adicionar'"
            remove-on-delete
            tag-class="tags"
            @tag-state="onTagState"
          />
          <small
            v-if="invalidTags.length > 0"
            class="text-danger"
          >Insira um email válido</small>
          <small
            v-else-if="duplicateTags.length > 0"
            class="text-danger"
          >E-mail já inserido nesse campo
          </small>
        </b-col>
      </b-row>

      <b-row v-if="showMore">
        <b-col
          cols="12"
          class="mb-1"
        >
          <legend
            v-if="valueInner.documentos && valueInner.documentos.length > 0"
            style="font-size: 1.15rem;"
          >
            Documentos</legend>
          <modelo-documento
            v-if="valueInner.documentos && valueInner.documentos.length > 0"
            v-model="valueInner.documentos"
            :aplicar-filtro="aplicarFiltro"
            :has-acoes="false"
            :documentos-da-empresa="false"
          />
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col
          class="pt-2"
        />
      </b-row>
    </b-col>
  </b-row>
</template>

<style lang="scss">
.question-icon {
  font-size: 0.65;
  align-self: center;
  display: block;
}

.tags {
  font-size: 12.6px;
}

.b-form-tags .b-form-tags-list .b-from-tags-field {
  margin-bottom: 0.25rem;
 }

.b-form-tags .b-form-tags-list .b-form-tag {
  margin-top: 0.1rem;
  margin-left: -0.5rem;
  margin-bottom: -0.1rem;
}

.div-email {
  display: flex;
}

.detail-check-sm.custom-checkbox.b-custom-control-sm
  .custom-control-label::before,
.detail-check-sm.input-group-sm .custom-checkbox .custom-control-label::before {
  left: 0px !important;
}

.detail-check-sm.custom-checkbox.b-custom-control-sm .custom-control-label {
  font-size: 1rem !important;
}

.label-question {
  font-size: x-small;
  cursor: pointer;
}

.contato-row {
  .row-btn {
    padding: 0.2rem;
    width: 1.9rem !important;
    border-radius: 100%;
  }

  &:hover {
    background-color: rgba(24, 28, 33, 0.03);
    border-radius: 1px;
  }

  .content-control {
    cursor: pointer;
    font-size: 12px;
    display: flex;
    & div {
      margin-left: auto;
      margin-right: auto;
      display: flex;
      flex-direction: column;
      & i {
        margin-left: 2.3rem;
      }
    }
  }
}

.usuario-select {
  .v-select {
    .vs__selected-options {
      flex-wrap: nowrap;
      max-width: calc(100% - 25px);
    }

    .vs__selected {
      display: block;
      white-space: nowrap;
      text-overflow: ellipsis;
      max-width: 100%;
      overflow: hidden;
    }
  }
}
</style>

<script>
/* eslint-disable no-param-reassign */
import { mapGetters } from 'vuex'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import 'moment/locale/pt-br'
import {
  faQuestionCircle, faExternalLinkAlt,
} from '@fortawesome/free-solid-svg-icons'
import { isAdmin, permitidoAcessarRecurso } from '@/auth/utils'
import { abrirEmNovaGuia } from '@/@core/utils/utils'

export default {
  name: 'ContatoRow',
  components: {
    FontAwesomeIcon,
    CabecalhoRepeticao: () => import('@/shared/components/cabecalho-repeticao/CabecalhoRepeticao.vue'),
    UsuarioExternoSelect: () => import('@/shared/components/usuario-externo-select/UsuarioExternoSelect.vue'),
    DepartamentoSelect: () => import('@/shared/components/departamento-select/DepartamentoSelect.vue'),
    ModeloDocumento: () => import('@/app-modulo/comuns/empresa/shared/components/modelo-documento/ModeloDocumento.vue'),
  },
  props: {
    value: {
      type: Object,
      default: () => { },
    },
    showMore: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {
      faQuestionCircle,
      faExternalLinkAlt,
      valueInner: {
        receberEmail: true,
        departamentos: [],
        emailsCC: [],
      },
      documentosContato: [],
      aplicarFiltro: false,
      invalidTags: [],
      duplicateTags: [],
      usuarioInativo: false,
    }
  },
  computed: {
    ...mapGetters('empresa', ['documentosSelecionados', 'empresa', 'filtrarDocsContato', 'getCopiaEmpresaDocumentos']),
    filtroUsuarioEmpresa: {
      get() {
        return [{
          colunas: ['Empresa'],
          valor: this.empresa.id,
        }]
      },
    },
    departamentos: {
      get() {
        return !this.valueInner || !this.valueInner.usuario ? null : this.valueInner.usuario.departamentos
      },
    },
    funcao: {
      get() {
        return !this.valueInner || !this.valueInner.usuario || !this.valueInner.usuario.funcao ? null : this.valueInner.usuario.funcao.nome
      },
    },
    telefone: {
      get() {
        return !this.valueInner || !this.valueInner.usuario ? null : this.valueInner.usuario.telefone
      },
    },
    celular: {
      get() {
        return !this.valueInner || !this.valueInner.usuario ? null : this.valueInner.usuario.celular
      },
    },
    email: {
      get() {
        return !this.valueInner || !this.valueInner.usuario ? null : this.valueInner.usuario.email
      },
    },
    disable: {
      get() {
        return !this.valueInner.receberEmail
      },
    },
  },
  watch: {
    value(value, oldValue) {
      if (value !== oldValue) {
        this.valueInner = value
      }
    },
    filtrarDocsContato(value, oldValue) {
      if (value !== oldValue) {
        this.aplicarFiltro = value
      }
    },
  },
  created() {
    this.valueInner = this.value
    if (!this.valueInner.documentos) {
      this.$set(this.valueInner, 'documentos', [])
    }
  },
  methods: {
    // ...mapActions('empresa', ['carregarDocumentosDeEmpresa']),
    carregarDocumentos() {
      this.$set(this.valueInner, 'documentos', this.getCopiaEmpresaDocumentos(this.valueInner, this.valueInner.departamentos))
    },
    adicionarItem() {
      if (this.contatoValido()) {
        this.$emit('novo')
      }
    },
    removerItem() {
      this.valueInner.usuario = []
      this.$emit('remove', this.valueInner)
    },
    more() {
      this.showMore = !this.showMore
    },
    contatoValido() {
      let valido = true
      this.$set(this.valueInner, 'erro', {})

      if (!this.valueInner.usuario) {
        this.$set(this.valueInner.erro, 'usuario', true)
        valido = false
      }

      if (!this.valueInner.departamentos || this.valueInner.departamentos.length <= 0) {
        this.$set(this.valueInner.erro, 'departamento', true)
        valido = false
      }
      return valido
    },
    removerUsuarioDuplicado(usuarios) {
      const usuariosExistentes = this.empresa.contatos.filter(fil => fil.usuario)

      if (usuariosExistentes && usuariosExistentes.length > 0) {
        const usuariosFiltrados = []
        usuarios.forEach(each => {
          if (!usuariosExistentes.find(index => index.usuario.id === each.id)) {
            usuariosFiltrados.push(each)
          }
        })
        return usuariosFiltrados
      }
      return null
    },
    filtrarDepartamentosPorUsuario(deps) {
      if (this.valueInner.usuario) {
        const depsFiltrados = []
        deps.forEach(dep => {
          if (this.valueInner.usuario.departamentos.find(find => find.id === dep.id)) {
            depsFiltrados.push(dep)
          }
        })
        return depsFiltrados
      }
      return null
    },
    copiaDocsSelecionados() {
      const copiaDocs = []
      this.documentosSelecionados.forEach(each => {
        const copia = { ...each }
        copia.departamento = { ...each.departamento }
        copia.documentos = []

        each.documentos.forEach(doc => {
          const copiaDoc = { ...doc }
          copia.documentos.push(copiaDoc)
        })

        copiaDocs.push(copia)
      })

      return copiaDocs
    },
    atualizaLinha(contato) {
      this.value.usuarioInativo = !contato.empresaAtiva
      this.valueInner.departamentos = []
      this.carregarDocumentos()
    },
    nomeUsuario() {
      if (!this.valueInner.usuario) {
        return ''
      }
      return this.valueInner.usuario.nomeCompleto
    },
    validator(tag) {
      const re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(tag)
    },
    onTagState(valid, invalid, duplicate) {
      this.invalidTags = invalid
      this.duplicateTags = duplicate
    },
    abrirGridUsuarioExterno() {
      if (isAdmin()) {
        if (this.valueInner.usuario && this.valueInner.usuario.id > 0) {
          abrirEmNovaGuia('editar-usuario-externo', this.valueInner.usuario.id)
        } else {
          abrirEmNovaGuia('usuariosexternos')
        }
      } else {
        const ability = permitidoAcessarRecurso('usuexterno')
        if (ability) {
          if (this.valueInner.usuario && this.valueInner.usuario.id > 0 && ability.actions.some(som => som === 'update')) {
            abrirEmNovaGuia('editar-usuario-externo', this.valueInner.usuario.id)
          } else {
            abrirEmNovaGuia('usuariosexternos')
          }
        } else {
          this.$erro('Você não tem permissão para acessar esse cadastro. Contate o administrador!')
        }
      }
    },
  },
}
</script>
